import { observable, action } from "mobx";
import moment from 'moment';

export default class CustomFilterStore {

    @observable dateRange = {
        fromDate: moment(),
        toDate: moment()
    }

    @observable isDateRangeModalOpen = false;
    @observable tempFromDate = null;
    @observable tempToDate = null;
    @observable dateRangePickerKey = 0;

    @action updateDateRange(key, value) {
        this.dateRange[key] = value;
    }

    @action reset() {
        this.dateRange.fromDate = moment();
        this.dateRange.toDate = moment();
    }

    @action openDateRangeModal(fromDate, toDate) {
        this.isDateRangeModalOpen = true;
        this.tempFromDate = fromDate;
        this.tempToDate = toDate;
        this.dateRangePickerKey += 1;
    }

    @action closeDateRangeModal() {
        this.isDateRangeModalOpen = false;
        this.tempFromDate = null;
        this.tempToDate = null;
    }

    @action updateTempDates(fromDate, toDate) {
        this.tempFromDate = fromDate;
        this.tempToDate = toDate;
    }

    @action clearTempDates() {
        this.tempFromDate = null;
        this.tempToDate = null;
        this.dateRangePickerKey += 1;
    }
}


// WEBPACK FOOTER //
// ./src/app/stores/CustomFilterStore.js